export default __webpack_public_path__ + "static/de-54518847261b34f6e7a122cf0e6a3bb3.svg";